export class SapObject {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "technicalName",
            "baseName": "technicalName",
            "type": "string",
            "format": ""
        },
        {
            "name": "description",
            "baseName": "description",
            "type": "string",
            "format": ""
        },
        {
            "name": "module",
            "baseName": "module",
            "type": "string",
            "format": ""
        },
        {
            "name": "type",
            "baseName": "type",
            "type": "SapObjectType",
            "format": ""
        },
        {
            "name": "abapPackage",
            "baseName": "abapPackage",
            "type": "string",
            "format": ""
        },
        {
            "name": "rowCount",
            "baseName": "rowCount",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "estBytes",
            "baseName": "estBytes",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "deltaCapability",
            "baseName": "deltaCapability",
            "type": "SapDeltaCapability",
            "format": ""
        },
        {
            "name": "recommended",
            "baseName": "recommended",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "columns",
            "baseName": "columns",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "sampleRows",
            "baseName": "sampleRows",
            "type": "Array<Array<SapObjectSampleRowsInnerInner>>",
            "format": ""
        },
        {
            "name": "lastChanged",
            "baseName": "lastChanged",
            "type": "Date",
            "format": "date-time"
        }
    ];
    static getAttributeTypeMap() {
        return SapObject.attributeTypeMap;
    }
    constructor() {
    }
}
